module.exports = __webpack_public_path__ + "assets/img/instagram.04ccb324.b194300a.svg";